import * as Sentry from "@sentry/react";
import { isTraceableHost, resolveAppEnvironment } from "./sentry-environment";
import { onBeforeSend } from "./sentry-events";

/**
 * Initializes Sentry on the browser.
 *
 * Events from localhost and other unknown hosts are not traced: the SDK is
 * not initialized at all, so nothing is ever sent.
 */
if (
  isTraceableHost(window.location.hostname) &&
  process.env.REACT_APP_SENTRY_DSN
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment:
      resolveAppEnvironment(window.location.hostname) ?? "development",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    // Enable logs to be sent to Sentry
    enableLogs: true,
    tracePropagationTargets: ["localhost"],
    beforeSend: onBeforeSend,
  });
}
